"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Dropdown = function (_a) {
    var anchorEl = _a.anchorEl, setAnchorEl = _a.setAnchorEl, onExit = _a.onExit, children = _a.children;
    var onClose = function () { return setAnchorEl(null); };
    return (react_1.default.createElement(StyledDropdown, { anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, anchorEl: anchorEl, open: !!anchorEl, onClose: onClose, classes: { paper: 'paper' }, disableRestoreFocus: true, "data-testid": "tag-dropdown-menu", onExit: onExit },
        react_1.default.createElement(StyledListContainer, null, children)));
};
exports.default = Dropdown;
var StyledDropdown = styled_components_1.default(core_1.Popover)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  .paper {\n    border-radius: 0;\n    border: 1px solid ", ";\n    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);\n\n    margin-top: 0.3rem;\n    min-width: 23rem;\n  }\n"], ["\n  .paper {\n    border-radius: 0;\n    border: 1px solid ", ";\n    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);\n\n    margin-top: 0.3rem;\n    min-width: 23rem;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[200];
});
var StyledListContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin: 0.6rem 0;\n"], ["\n  margin: 0.6rem 0;\n"])));
var templateObject_1, templateObject_2;
